<template>
  <div class="training-camp-details">
    <div class="details-fixed">
      <div class="detail-con">
        <div class="back" @click="back">
          <div class="icon-left"></div>
          <div>返回列表</div>
        </div>
        <div class="hospital-base">
          <img :src="details.headImgUrl" class="hospital-img" alt=""/>
          <div class="hospital-name">{{ details.hospitalName }}</div>
        </div>
<!--        <van-icon name="arrow-down" class="hospital-arrow"/>-->
      </div>
      <div class="sec-flex">
        <div
          v-for="item in tabs"
          :key="item.code"
          :class="['flex-txt', Number(activeTab) === Number(item.code) ? 'cur' : '']"
          @click="changeTab(item.code)"
        >
          <span class="txt">{{ item.name }}</span>
        </div>
      </div>
    </div>
    <div class="detail-content" :class="{ 'is-empty': isEmptyContent }">
      <div
        v-for="tab in tabs"
        :key="`tab-pane-${tab.code}`"
        v-if="isTabVisited(tab.code)"
        v-show="Number(activeTab) === Number(tab.code)"
        class="materials-pane"
      >
        <template v-if="isLivePlaybackTab(tab.code)">
          <van-list
            v-if="livePlaybackList.length"
            v-model="getTabState(tab.code).loading"
            :finished="getTabState(tab.code).finished"
            :finished-text="getFinishedText(tab.code)"
            :immediate-check="true"
            :offset="10"
            @load="handleTabLoad(tab.code)"
          >
            <div class="replay-list">
              <div
                class="replay-item"
                v-for="(item, index) in livePlaybackList"
                :key="item.materialId || item.id || index"
                @click="handleReplayClick(item)"
              >
                <img
                  :src="item.coverMaterialUrl"
                  class="replay-cover"
                  alt="直播回放封面"
                />
                <div class="replay-info">
                  <div class="replay-title">{{ item.videoTitle || item.name }}</div>
                </div>
              </div>
            </div>
          </van-list>
          <div class="replay-none" v-else-if="shouldShowEmpty(tab.code)">
            <img src="@/assets/images/home/live_none.png" class="none-img" alt="暂无直播回放"/>
            <div class="none-txt">暂无直播回放</div>
          </div>
        </template>
        <template v-else>
          <van-list
            v-if="getMaterials(tab.code).length"
            v-model="getTabState(tab.code).loading"
            :finished="getTabState(tab.code).finished"
            finished-text=""
            :immediate-check="true"
            :offset="10"
            @load="handleTabLoad(tab.code)"
          >
            <div
              v-for="(material, index) in getMaterials(tab.code)"
              :key="material.materialId || material.materialUrl || index"
              class="material-card"
            >
              <img
                v-if="material.materialType === 'image'"
                :src="material.materialUrl"
                class="material-img"
                alt="图片素材"
              />
              <template v-else>
                <div v-if="isVodMaterial(material)" class="video-player-block">
                  <TrainingCampVideoPlayer
                    ref="videoPlayers"
                    :playerVideo="mapToPlayerVideo(material)"
                  />
                </div>
              </template>
            </div>
          </van-list>
          <div v-else-if="shouldShowEmpty(tab.code)" class="replay-none">
            <img src="@/assets/images/home/live_none.png" class="none-img" alt="暂无内容"/>
            <div class="none-txt">暂无内容</div>
          </div>
        </template>
      </div>
    </div>
    <custom-dialog
      :visible.sync="cDialog.visible"
      @cancel="cDialog.cancel"
      @confirm="cDialog.confirm"
      @close="cDialog.close"
      v-bind="cDialog"
    >
      <div class="txts">{{ cDialog.content }}</div>
    </custom-dialog>
  </div>
</template>

<script>
import withRouteTracking from '@/utils/withRouteTracking'
import TrainingCampVideoPlayer from './compontents/TrainingCampVideoPlayer.vue'
import {isScorm} from '../../api/scorm'
import {getTrainingCampDetail, zoneUserVisit, getTrainingCampTabData} from '@/api/zone'
import CustomDialog from '@/views/cartoJourney/components/CustomDialog.vue'
import {getShareInfo} from '@/utils/wxShare'
const defaultTabList = [
  {code: 1, name: '中心介绍'},
  {code: 2, name: '培训计划'},
  {code: 3, name: '直播回放'}
]

const LIVE_PLAYBACK_TAB_CODE = 3

const UserProfile = {
  name: 'TrainingCampDetails',
  components: {
    TrainingCampVideoPlayer,
    CustomDialog
  },
  data() {
    return {
      activeTab: defaultTabList[0].code,
      details: {},
      visitedTabs: [defaultTabList[0].code],
      loadedParts: [],
      tabState: {},
      areaUnavailable: false,
      cDialog: {
        visible: false,
        showCancelButton: false,
        confirmButtonText: '我知道了',
        content: '该研修营已下架',
        showCloseIcon: false,
        cancel: () => {
          this.handleDialogClose()
        },
        confirm: () => {
          this.handleDialogClose()
        },
        close: () => {
          this.handleDialogClose()
        }
      }
    }
  },
  computed: {
    activeMaterials() {
      const info = this.details.info || {}
      return info[this.activeTab] || []
    },
    tabs() {
      return defaultTabList
    },
    livePlaybackTabCode() {
      const tab = (this.tabs || []).find(item => item.name === '直播回放')
      return tab ? Number(tab.code) : LIVE_PLAYBACK_TAB_CODE
    },
    livePlaybackList() {
      return this.getMaterials(this.livePlaybackTabCode)
    },
    isLivePlaybackActive() {
      return Number(this.activeTab) === this.livePlaybackTabCode
    },
    isEmptyContent() {
      if (this.isLivePlaybackActive) return false
      return this.shouldShowEmpty(this.activeTab)
    },
    userInfo() {
      return this.$store.getters.userInfo
    }
  },
  async mounted() {
    // 存储当前的研修营，在首页点击培训中心会判断
    sessionStorage.removeItem('entrance')
    this.recordUserVisit()
    const isAvailable = await this.getTrainingCampDetailData()
    if (isAvailable) {
      this.getTrainingCampTabInfo(this.activeTab)
    }
  },
  methods: {
    // 切换 tab，暂停已播视频，并在未加载时触发对应 part 的首次拉取
    changeTab(code) {
      if (this.areaUnavailable) return
      const nextTab = Number(code)
      if (Number(this.activeTab) !== nextTab) {
        this.pauseAllVideos()
      }
      this.activeTab = nextTab
      if (!this.visitedTabs.includes(nextTab)) {
        this.visitedTabs.push(nextTab)
      }
      const state = this.getTabState(nextTab)
      if (!this.hasLoadedPart(nextTab) && !state.loading) {
        this.getTrainingCampTabInfo(nextTab)
      }
    },
    // 暂停所有已渲染的视频播放器
    pauseAllVideos() {
      const refs = this.$refs.videoPlayers
      if (!refs) return
      const players = Array.isArray(refs) ? refs : [refs]
      players.forEach(player => {
        if (player && typeof player.pausePlayback === 'function') {
          player.pausePlayback()
        }
      })
    },
    // 判断是否为直播回放 tab
    isLivePlaybackTab(code) {
      return Number(code) === this.livePlaybackTabCode
    },
    // 返回上一页
    handleBack() {
      this.$router.back()
    },
    // 当前 tab 是否已访问过（用于懒加载显示控制）
    isTabVisited(code) {
      return this.visitedTabs.includes(Number(code))
    },
    // 获取指定 tab 的素材列表
    getMaterials(code) {
      const info = this.details.info || {}
      return info[code] || []
    },
    // 获取并初始化指定 tab 的分页状态
    getTabState(code) {
      return this.ensureTabState(code)
    },
    // 仅获取已存在的 tab 状态
    peekTabState(code) {
      const normalized = Number(code)
      return this.tabState[normalized]
    },
    // 判断素材是否为点播视频
    isVodMaterial(material) {
      return Boolean(material && material.fileId && material.appId && material.psign)
    },
    // 将素材映射为播放器所需字段
    mapToPlayerVideo(material = {}) {
      return {
        id: material.materialId,
        title: material.videoTitle || '',
        fileId: material.fileId,
        appId: material.appId,
        psign: material.psign,
        coverUrl: material.coverMaterialUrl || '',
        knowledgeList: material.knowledgeList || []
      }
    },
    // 直播回放点击，判断是否为 scorm 并跳转对应详情
    async handleReplayClick(item) {
      // 判断是scorm视频还是普通视频
      const res = await isScorm(item.materialId)
      let path = '/courserDetails'
      if (res.data) {
        path = '/scormCourseDetail'
      }
      this.$router.push({
        path: path,
        query: {
          courseId: item.materialId,
          businessId: this.$route.query.id,
          entrance: 101,
          channel: 101,
        }
      })
    },
    handleDialogClose() {
      this.cDialog.visible = false
      this.back()
    },
    // 获取研修营详情（基础信息 + 初始 info）
    async getTrainingCampDetailData() {
      if (!this.$route.query.id) return false
      const {data, code} = await getTrainingCampDetail({id: this.$route.query.id})
      if (code === 0) {
        const detailData = data || {}
        const info = detailData.info || this.details.info || {}
        this.details = {...detailData, info}
        window.sessionStorage.setItem('mainId', this.details.id)
        window.sessionStorage.setItem('serviceId', this.details.id)
        let entrance = (this.$route.query.entrance) ? this.$route.query.entrance : ''
        window.sessionStorage.setItem('entrance', entrance)
        window.sessionStorage.setItem('traceTitle', '研修营专区详情-' + this.details.hospitalName)
        getShareInfo({
          title: this.details.hospitalName,
          titleTimeLine: this.details.hospitalName,
          desc: `研修营专区：${this.details.hospitalName}`,
          link: window.location.href, // modifyURLParam(window.location.href, 'entrance', '20'),
          linkTimeLine: window.location.href, // modifyURLParam(window.location.href, 'entrance', '21'),
          images: this.details.headImgUrl || `https://iep.jjmc.cn/bw/file/material/image/1933146816339349528.jpg`,
        })
        const areaStatus = Number(detailData.areaStatus)
        if (areaStatus !== 1) {
          this.areaUnavailable = true
          this.cDialog.visible = true
          return false
        }
        this.markLoadedPartsFromInfo(info)
        return true
      }
      return false
    },
    // 获取指定 part 的 tab 数据，支持加载更多
    async getTrainingCampTabInfo(part, options = {}) {
      if (this.areaUnavailable) return
      if (!this.$route.query.id) return
      const {isLoadMore = false} = options
      const normalizedPart = Number(part) || part
      const state = this.ensureTabState(normalizedPart)
      if (!isLoadMore) {
        state.pageNum = 1
        state.finished = false
      }
      if (isLoadMore && state.finished) return
      state.loading = true
      this.$toast.loading({message: '加载中...'})
      const params = {
        areaId: this.$route.query.id,
        part: normalizedPart,
        pageNum: state.pageNum,
        pageSize: state.pageSize
      }
      try {
        const {data, code} = await getTrainingCampTabData(params)
        if (code === 0 && data) {
          const existingInfo = this.details.info || {}
          const incomingList = Array.isArray(data.list) ? data.list : []
          const currentList = Array.isArray(existingInfo[normalizedPart]) ? existingInfo[normalizedPart] : []
          const nextList = isLoadMore ? currentList.concat(incomingList) : incomingList
          const nextInfo = {...existingInfo, [normalizedPart]: nextList}
          this.details = {...this.details, info: nextInfo}
          this.markPartLoaded(normalizedPart)
          const currentPage = Number(data.pageNum) || state.pageNum
          const totalPages = Number(data.pages) || 0
          if (totalPages > 0) {
            state.finished = currentPage >= totalPages
            state.pageNum = currentPage + 1
          } else if (!incomingList.length && isLoadMore) {
            state.finished = true
          } else {
            state.pageNum += 1
            state.finished = incomingList.length < state.pageSize
          }
          return
        }
        state.finished = true
      } catch (error) {
        state.finished = true
      } finally {
        state.loading = false
        this.$toast.clear()
      }
    },
    // 记录用户访问
    recordUserVisit() {
      if (!this.$route.query.id || !this.userInfo || !this.userInfo.id) return
      zoneUserVisit({
        areaId: this.$route.query.id,
        userId: this.userInfo.id,
        type: 2
      })
    },
    // 返回研修营列表页
    back() {
      this.$router.push({
        path: '/zoneList',
        query: {
          activeTab: '2'
        }
      })
    },
    // 判断 part 是否已拉取过
    hasLoadedPart(part) {
      const normalized = Number(part)
      return this.loadedParts.includes(normalized)
    },
    // 标记 part 已拉取
    markPartLoaded(part) {
      const normalized = Number(part)
      if (Number.isNaN(normalized)) return
      if (!this.loadedParts.includes(normalized)) {
        this.loadedParts.push(normalized)
      }
    },
    // 根据 info 对象批量标记已加载的 part
    markLoadedPartsFromInfo(info = {}) {
      const keys = Object.keys(info)
      keys.forEach(key => this.markPartLoaded(key))
    },
    // 初始化 tab 分页状态
    ensureTabState(part) {
      const normalized = Number(part)
      if (!this.tabState[normalized]) {
        this.$set(this.tabState, normalized, {
          pageNum: 1,
          pageSize: 10,
          loading: false,
          finished: false
        })
      }
      return this.tabState[normalized]
    },
    // 判定是否展示“暂无内容”，避免加载中出现塌陷闪烁
    shouldShowEmpty(code) {
      const list = this.getMaterials(code)
      if (list && list.length) return false
      const state = this.getTabState(code)
      return !state.loading && this.hasLoadedPart(code)
    },
    // 根据是否有列表数据决定“没有更多了”是否显示，避免与空状态并存
    getFinishedText(code) {
      const list = this.getMaterials(code)
      return list && list.length ? '没有更多了' : ''
    },
    // van-list 触底加载更多
    handleTabLoad(code) {
      const state = this.getTabState(code)
      const isLoadMore = this.hasLoadedPart(code) || state.pageNum > 1
      this.getTrainingCampTabInfo(code, {isLoadMore})
    }
  }
}

export default withRouteTracking(UserProfile)
</script>

<style lang="less" scoped>
.training-camp-details {
  min-height: 100vh;
  background: #F9F8F7;

  .details-fixed {
    padding: 12px 16px 14px 16px;
    position: sticky;
    top: 0;
    z-index:999;
    background: #F9F8F7;
  }

  .detail-con {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    .back{
      width: 102px;
      background-color: #FDFDFC;
      height: 60px;
      line-height: 60px;
      font-weight: 400;
      font-size: 14px;
      color: #343434;
      text-align: center;
      border-radius: 12px;
      display: flex;
      justify-items: center;
      align-items: center;
      .icon-left{
        width: 24px;
        height: 24px;
        background: url("~@/assets/images/left.png") no-repeat center center / 100% 100%;
      }
    }
    .hospital-base {
      height: 40px;
      display: flex;
      align-items: center;
      min-width: 0;
      background-color: #FDFDFC;
      flex: 1;
      border-radius: 12px;
      padding: 10px 12px 10px 37px;
    }

    .hospital-img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      object-fit: cover;
      margin-right: 12px;
      flex-shrink: 0;
    }

    .hospital-name {
      font-size: 14px;
      font-weight: 500;
      color: #202020;
      font-family: PingFang SC, PingFang SC;
      //  超过两行 显示省略号
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    .hospital-arrow {
      color: #c6cad0;
      font-size: 16px;
      flex-shrink: 0;
    }
  }

  .sec-flex {
    display: flex;
    box-sizing: border-box;
    align-items: center;
    justify-content: center;
    margin-top: 14px;
    gap: 12px;

    .flex-txt {
      position: relative;
      padding: 4px 12px;
      line-height: 1;
      font-size: 14px;
      color: #564C47;
      font-weight: 600;
      border-radius: 999px;
      background: #F2F0EE;
      text-align: center;

      &.cur {
        font-weight: 700;
        color: #EB1700;
        background: rgba(235, 23, 0, 0.05);
      }

      .txt {
        white-space: nowrap;
        display: inline-block;
      }
    }
  }

  .detail-content {
    position: relative;
  }

  .materials-pane {
    min-height: 300px; // 保持切换时容器高度，避免空态/加载阶段的闪烁
    position: relative;
    border-radius: 12px 12px 0 0;
    overflow: hidden;
  }

  .material-card {
    background-color: #fff;
    overflow: hidden;
  }

  .material-img {
    width: 100%;
    height: auto;
    display: block;
  }

  .empty-tips {
    width: 100%;
    text-align: center;
    font-size: 14px;
    color: #9aa0a8;
    padding: 28px 0 16px;
  }

  .replay-list {
    padding: 0 16px 16px;
    box-sizing: border-box;

    .replay-item {
      margin-top: 8px;
      border-radius: 12px;
      background-color: #fff;
      padding: 11px 13px 16px 10px;
      box-sizing: border-box;
      display: flex;

      .replay-cover {
        width: 80px;
        height: 80px;
        border-radius: 4px;
        overflow: hidden;
        display: block;
        margin-right: 8px;
        min-width: 80px;
        max-width: 80px;
        object-fit: cover;
      }

      .replay-info {
        flex: 1;

        .replay-title {
          line-height: 20px;
          font-size: 14px;
          color: #000000;
          margin-bottom: 17px;
          height: 40px;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
    }
  }

  .replay-none {
    display: block;

    .none-img {
      width: 185px;
      margin-top: 122px;
      margin-left: 50%;
      transform: translateX(-50%);
    }

    .none-txt {
      text-align: center;
      font-size: 12px;
      color: #949ba5;
      font-weight: 400;
      line-height: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/RTCZone/trainingCampDetails.vue